// TermsOfUsage.jsx
import React from 'react';
import TermsOfUsageData from './data';
import NavBar from '../ProductPage_v2/components/Navbar/Navbar';
import FooterSection from '../ProductPage_v2/components/footer/footer';

const TermsOfUsage = () => {
  return (
    <>
      <div className='w-screen bg-[#FBF8F3] relative z-0'>
        <img
          src="/assets/img/bgGrid.png"
          className="absolute top-0 left-0 h-auto w-auto sm:h-full sm:w-full -z-10"
        />
        <div className="relative w-full max-w-5xl mx-auto px-4 py-8  text-[#717171] z-0">
          <NavBar />
          <h1 className="text-3xl sm:text-5xl font-bomstad-semibold mb-6 mt-5 text-[#0A313C]">
           General Terms of Usage
          </h1>
          {TermsOfUsageData.map((item, index) => (
            <div key={index} className="mb-6 font-atkinson ">
              <h2 className="text-xl font-semibold mb-2">{item.heading}</h2>
              {item.content.split('\n').map((line, i) => (
                <p key={i} className="mb-2">
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
      <FooterSection />
    </>
  );
};

export default TermsOfUsage;
